var map = {
	"./account-icon.svg": 386,
	"./add-auth-user-icon.svg": 404,
	"./add-bill-icon.svg": 272,
	"./add-patient-icon.svg": 384,
	"./add-payment-icon.svg": 417,
	"./add-user-icon.svg": 377,
	"./appointment-icon.svg": 381,
	"./approved-icon-g.svg": 275,
	"./approved-icon-w.svg": 364,
	"./attachment-icon.svg": 449,
	"./authorize-icon.svg": 372,
	"./authorizer-icon.svg": 452,
	"./back-icon.svg": 455,
	"./bell-icon.svg": 366,
	"./billing-icon.svg": 388,
	"./bills-icon.svg": 391,
	"./blocked-user-icon.svg": 453,
	"./chain-link-icon.svg": 462,
	"./change-password.svg": 443,
	"./check-field-icon.svg": 441,
	"./clear-all-icon.svg": 457,
	"./dashboard-doctor-icon.svg": 398,
	"./dashboard-female-icon.svg": 403,
	"./dashboard-icon.svg": 379,
	"./dashboard-lab-icon.svg": 396,
	"./dashboard-logo.svg": 271,
	"./dashboard-male-icon.svg": 402,
	"./dashboard-patient-icon.svg": 395,
	"./dashboard-specimen-icon.svg": 273,
	"./dashboard-users-icon.svg": 401,
	"./date-icon.svg": 421,
	"./doc-icon.svg": 459,
	"./doctors-icon.svg": 399,
	"./edit-icon.svg": 428,
	"./employee-icon.svg": 387,
	"./eye-icon.svg": 406,
	"./female-profile-icon.svg": 416,
	"./file-cabinet-icon.svg": 461,
	"./filter-icon.svg": 367,
	"./folder-icon.svg": 460,
	"./form-icon.svg": 438,
	"./gync-form-icon.svg": 447,
	"./inbox-icon.svg": 407,
	"./info-icon.svg": 425,
	"./ip-select-indicator.svg": 1090,
	"./key-icon.svg": 369,
	"./labcode-icon.svg": 436,
	"./labs-icon.svg": 397,
	"./lock-icon.svg": 423,
	"./logo.svg": 471,
	"./logout-icon.svg": 434,
	"./long-arrow-icon.svg": 424,
	"./message-icon.svg": 410,
	"./more-icon.svg": 385,
	"./multi-user-icon.svg": 451,
	"./new-message-icon.svg": 411,
	"./no-notification-icon.svg": 456,
	"./non-gync-form-icon.svg": 448,
	"./option-icon.svg": 378,
	"./overview-icon.svg": 371,
	"./password-star.svg": 444,
	"./patient-icon.svg": 383,
	"./pay-advice-blue-icon.svg": 419,
	"./pay-advice-icon.svg": 420,
	"./payment-icon-2.svg": 389,
	"./payments-icon.svg": 418,
	"./payroll-icon.svg": 1091,
	"./plus-icon.svg": 274,
	"./power-icon.svg": 433,
	"./print-icon.svg": 458,
	"./profile-icon.svg": 276,
	"./profile-image-placeholder.svg": 394,
	"./profile-settings.svg": 442,
	"./question-mark-icon.svg": 435,
	"./read-receipt-icon.svg": 413,
	"./recent-icon.svg": 370,
	"./remove-auth-user-icon.svg": 405,
	"./remove-icon.svg": 414,
	"./reply-icon.svg": 409,
	"./report-icon.svg": 390,
	"./report-type-icon1.svg": 1092,
	"./requisition-icon.svg": 376,
	"./requisition-link-icon.svg": 450,
	"./reset-icon.svg": 429,
	"./result-sheet-icon.svg": 1093,
	"./results-icon.svg": 392,
	"./role-black-icon.svg": 422,
	"./role-icon.svg": 400,
	"./role-permission-icon.svg": 437,
	"./sample-icon.svg": 373,
	"./sample-multi-icon.svg": 375,
	"./sample-single-icon.svg": 382,
	"./save-icon.svg": 454,
	"./search-icon.svg": 430,
	"./sent-icon.svg": 408,
	"./services-icon.svg": 439,
	"./setting-icon.svg": 431,
	"./settings-icon.svg": 432,
	"./short-arrow-icon.svg": 368,
	"./signature-placeholder-bk.svg": 1094,
	"./signature-placeholder.svg": 363,
	"./single-user-icon.svg": 415,
	"./slide-cell-1.svg": 1095,
	"./slide-cell-2.svg": 1096,
	"./slide-cell-3.svg": 1097,
	"./slide-cell-4.svg": 1098,
	"./slide-cell-5.svg": 1099,
	"./slide-cell.svg": 1100,
	"./slide-icon.svg": 374,
	"./specimen-two-icon.svg": 445,
	"./submit-icon.svg": 446,
	"./text-field-icon.svg": 440,
	"./trash-icon.svg": 412,
	"./unpaid-icon.svg": 393,
	"./user-role-type-icon.svg": 426,
	"./users-icon.svg": 380,
	"./view-icon.svg": 365,
	"./workspace-role-type-icon.svg": 427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1089;